/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from 'reactstrap'
import ValidateMessage from '../../components/generics/ValidateMessage'
import InputMask from 'react-input-mask'
import Button from '../../components/generics/Button'
import { useNavigate, useLocation } from 'react-router-dom'
import infoStore from '../../core/stores/Viriyah/infoStore'
import tokenStore from '../../core/stores/Viriyah/tokenStore'
import otpStore from '../../core/stores/Viriyah/otpStore'
import liff from '@line/liff'
import { Text } from '@chakra-ui/react'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjs from 'dayjs'
// const NodeRSA = require('node-rsa')

// validate
import * as validate from '../../core/utils/Validate'
import { view } from 'react-easy-state'
import { mappingMessageCode } from '../../core/utils/Utils'
import userStore from '../../core/stores/Viriyah/userStore'
const crypto = require('crypto')

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Bangkok')

interface SignInFormState {
  firstName: string
  lastName: string
  birthday: string
  idCardNumber: string
  laser: string
  email: string
  mobileNumber: string
  firstNameStatus: validate.ErrorStatus
  lastNameStatus: validate.ErrorStatus
  birthdayStatus: validate.ErrorStatus
  idCardNumberStatus: validate.ErrorStatus
  laserStatus: validate.ErrorStatus
  emailStatus: validate.ErrorStatus
  mobileNumberStatus: validate.ErrorStatus
  errorMessage: validate.ErrorStatus
  dopaErrorMessage: validate.ErrorStatus
  memberUserErrorMessage: validate.ErrorStatus
}

export default view(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  // const location = useLocation()
  const formDiv = React.useRef(null)
  const scrollToTop = () => {
    // @ts-expect-error
    formDiv.current.scrollTo(0, 0)
  }

  const [form, setState] = React.useState<SignInFormState>({
    firstName: '',
    lastName: '',
    birthday: '',
    idCardNumber: '',
    laser: '',
    email: '',
    mobileNumber: '',
    firstNameStatus: { message: '', status: false },
    lastNameStatus: { message: '', status: false },
    birthdayStatus: { message: '', status: false },
    idCardNumberStatus: { message: '', status: false },
    laserStatus: { message: '', status: false },
    emailStatus: { message: '', status: false },
    mobileNumberStatus: { message: '', status: false },
    errorMessage: { message: '', status: false },
    dopaErrorMessage: { message: '', status: false },
    memberUserErrorMessage: { message: '', status: false }
  })

  const handleTextChange = (e: { target: { name: string; value: any } }) => {
    const name: string = e.target.name
    const value = e.target.value

    setState({
      ...form,
      [name]: e.target.value,
      errorMessage: { message: '', status: false }
    })

    if (name === 'firstName') {
      setState(form => ({
        ...form,
        firstNameStatus: validate.checkEmpty(value, t('viriyah.validate-message.login-form.firstName'))
      }))
    }

    if (name === 'lastName') {
      setState(form => ({
        ...form,
        lastNameStatus: validate.checkEmpty(value, t('viriyah.validate-message.login-form.lastName'))
      }))
    }

    if (name === 'birthday') {
      const errorMessage = chkBirthday(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        birthdayStatus: { message: errorMessage, status: errorStatus }
      }))
    }

    if (name === 'idCardNumber' && value.length === 17) {
      const errorMessage = chkDigitPid(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        idCardNumberStatus: { message: errorMessage, status: errorStatus }
      }))
    }

    if (name === 'laser' && value.length === 14) {
      const errorMessage = chkLaser(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        laserStatus: { message: errorMessage, status: errorStatus }
      }))
    }

    if (name === 'email') {
      const errorMessage = chkEmail(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        emailStatus: { message: errorMessage, status: errorStatus }
      }))
    }

    if (name === 'mobileNumber' && value.length === 9) {
      const errorMessage = chkMobileNumber(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        mobileNumberStatus: { message: errorMessage, status: errorStatus }
      }))
    }
  }

  const checkValidate = (e: any) => {
    const name: any = e.target.name
    const value = e.target.value

    if (name === 'firstName') {
      setState(form => ({
        ...form,
        firstNameStatus: validate.checkEmpty(value, t('viriyah.validate-message.login-form.firstName'))
      }))
    }

    if (name === 'lastName') {
      setState(form => ({
        ...form,
        lastNameStatus: validate.checkEmpty(value, t('viriyah.validate-message.login-form.lastName'))
      }))
    }

    if (name === 'birthday') {
      const errorMessage = chkBirthday(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        birthdayStatus: { message: errorMessage, status: errorStatus }
      }))
    }

    if (name === 'idCardNumber') {
      // validate idCardNumber
      if (value) {
        const errorMessage = chkDigitPid(value)
        let errorStatus: boolean

        if (errorMessage === '') errorStatus = true
        else errorStatus = false

        setState(form => ({
          ...form,
          idCardNumberStatus: { message: errorMessage, status: errorStatus }
        }))
      }
    }
    if (name === 'laser') {
      // validate laser
      const errorMessage = chkLaser(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        laserStatus: { message: errorMessage, status: errorStatus }
      }))
    }
    if (name === 'email') {
      // validate email
      const errorMessage = chkEmail(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        emailStatus: { message: errorMessage, status: errorStatus }
      }))
    }
    if (name === 'mobileNumber') {
      // validate mobileNumber
      const errorMessage = chkMobileNumber(value)
      let errorStatus: boolean

      if (errorMessage === '') errorStatus = true
      else errorStatus = false

      setState(form => ({
        ...form,
        mobileNumberStatus: { message: errorMessage, status: errorStatus }
      }))
    }
  }

  const chkDigitPid = (e: string) => {
    let total = 0
    let iPID
    let chk
    let Validchk
    let errorMessage
    iPID = e.replace(/-/g, '')
    Validchk = iPID.substr(12, 1)
    let j = 0
    let pidcut
    for (let n = 0; n < 12; n++) {
      pidcut = parseInt(iPID.substr(j, 1))
      total = total + pidcut * (13 - n)
      j++
    }

    chk = 11 - (total % 11)

    if (chk === 10) {
      chk = 0
    } else if (chk === 11) {
      chk = 1
    }
    if (chk.toString() !== Validchk) {
      return (errorMessage = t('viriyah.validate-message.login-form.idCardNumber'))
    } else {
      return (errorMessage = '')
    }
  }

  const chkLaser = (e: string) => {
    let errorMessage
    const input = e.replace(/-/g, '')
    const regExp = /^([A-Z]){2}\d{10}$/

    const chk = regExp.test(input)

    if (!chk) {
      return (errorMessage = t('viriyah.validate-message.login-form.laser'))
    } else {
      return (errorMessage = '')
    }
  }

  const chkEmail = (e: string) => {
    let errorMessage
    const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    const chk = regExp.test(e)

    if (!chk) {
      return (errorMessage = t('viriyah.validate-message.login-form.email'))
    } else {
      return (errorMessage = '')
    }
  }

  const chkMobileNumber = (e: string) => {
    let errorMessage
    const regExp = /^0[0-9]{8,9}$/i

    const chk = regExp.test(e)
    if (!chk) {
      return (errorMessage = t('viriyah.validate-message.login-form.mobileNumber'))
    } else {
      return (errorMessage = '')
    }
  }

  const delHyphen = (e: string) => {
    const ans = e.replace(/-/g, '')
    return ans
  }

  const delSlash = (e: string) => {
    const ans = e.replace(/\//g, '')
    return ans
  }

  const mobilelast4digit = (e: string) => {
    return e.substr(-4)
  }

  const encryptedData = (e: any) => {
    const algorithm = 'aes-256-cbc'
    const key = '9ccd58baf4b56cfacd80429f671b5c91302f862a8d9d751647042e8bfd888a7f'
    const iv = 'd4a5f6b7350d1ebd12faed4388cafc1e'
    const cipher = crypto.createCipheriv(algorithm, Buffer.from(key, 'hex'), Buffer.from(iv, 'hex'))
    let encrypted = cipher.update(e)
    encrypted = Buffer.concat([encrypted, cipher.final()]).toString('hex')
    return encrypted
  }

  // status = true, is not emtpy or not error
  const checkFormInput = (): boolean => {
    if (
      form.firstNameStatus.status &&
      form.lastNameStatus.status &&
      form.birthdayStatus.status &&
      form.idCardNumberStatus.status &&
      form.laserStatus.status &&
      form.emailStatus.status &&
      form.mobileNumberStatus.status &&
      form.mobileNumber.length >= 9 &&
      form.mobileNumber.length <= 10 &&
      form.birthday !== ''
    ) {
      return false
    } else {
      return true
    }
  }

  const chkDOPA = () => {
    const pathName = 'DopaCheck'
    const payload = {
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      pid: delHyphen(form.idCardNumber),
      laser: delHyphen(form.laser),
      birthDay: toBEyear(delHyphen(form.birthday)),
      userId: userStore.userId
    }
    setState({
      ...form,
      errorMessage: { message: '', status: false }
    })
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('DopaCheck : ', response)
        if (response === 'success') {
          // registerMember()
          chkMyPolicy()
          setState({
            ...form,
            dopaErrorMessage: { message: '', status: false }
          })
        } else {
          console.log('DopaCheck not success!!!')
          let errorMessage = ''
          if(response.desc) {
            errorMessage = mappingMessageCode(response.desc, 20, response?.status)
          }else{
            errorMessage = mappingMessageCode(t('viriyah.validate-message.check-dopa'), 20, response?.status)
          }
          setState({
            ...form,
            dopaErrorMessage: { message: errorMessage, status: true }
          })
          scrollToTop()
        }
      })
      .catch(err => {
        console.log(err)

        let errorMessage = ''
        if (err.message === 'Network Error') {
          errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), '', err.status)
        } else errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 20, err.response?.status)
        setState({
          ...form,
          dopaErrorMessage: { message: errorMessage, status: true }
        })
        scrollToTop()
      })
  }

  const registerMember = () => {
    const nr = Math.random()
    let ncd = ''
    for (let i = 0; i < 7; i++) {
      ncd = ncd + (Math.floor(nr * 10 ** (i + 1)) % 10)
      if (i === 6) {
        const pathName = 'registerMember'
        const payload = {
          firstName: form.firstName.trim(),
          lastName: form.lastName.trim(),
          birthday: toBEyear(delHyphen(form.birthday)),
          idCardNumber: encryptedData(delHyphen(form.idCardNumber)),
          laser: encryptedData(delHyphen(form.laser)),
          email: form.email,
          mobileNumber: form.mobileNumber,
          userId: userStore.userId
        }
        window.bizlink
          .trigger('POST', {
            payload,
            pathName
          })
          .then((response: any) => {
            console.log(response)

            if (response.success) {
              infoStore.setAll(
                form.firstName,
                form.lastName,
                form.birthday,
                form.idCardNumber,
                form.laser,
                form.email,
                form.mobileNumber
              )
              navigate('/otp-request', { replace: true })
              generateOTP()
              // chkMyPolicy()
            } else {
              console.log('registerMember not success!!!', response)
              const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 30, response.status)
              setState({
                ...form,
                errorMessage: {
                  message: errorMessage,
                  status: true
                }
              })
              scrollToTop()
            }
          })
          .catch(err => {
            console.log('error', pathName, 'with', err.message)
            const errorMessage = mappingMessageCode(
              t('viriyah.validate-message.service-error'),
              30,
              err.response?.status
            )
            setState({
              ...form,
              errorMessage: {
                message: errorMessage,
                status: true
              }
            })
            scrollToTop()
          })
      }
    }
  }

  const chkMyPolicy = () => {
    const pathName = 'myPolicy'
    const payload = {
      thaiid: delHyphen(form.idCardNumber),
      thfirstname: form.firstName.trim(),
      thlastname: form.lastName.trim(),
      mobilelast4digit: mobilelast4digit(form.mobileNumber),
      userId: userStore.userId
    }
    setState({
      ...form,
      errorMessage: { message: '', status: false }
    })
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('myPolicy response : ', response)
        let isPolicyExist = response.policy ? true : false ;
        console.log('isPolicyExist: ', isPolicyExist)
        if (!response.error) {
          registerMember()
          
        } else if(!isPolicyExist){
          console.log('no policy!', response)
          const integrationStatusCode =  response.integrationStatusCode
          if(integrationStatusCode && integrationStatusCode === '2_API_102'){  
            const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 40, response.status ? response.status : 404)
            setState({
                ...form,
                errorMessage: { message: errorMessage, status: true },
            });
          }else{
            const errorMessage = mappingMessageCode(t('viriyah.validate-message.check-my-policy.no-policy'), 40, response.status ? response.status : 400)
            setState({
                ...form,
                errorMessage: { message: errorMessage, status: true },
            });
          }
          scrollToTop();
        } else {
          console.log('getMember not success!!!', response)
          const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 40, response.status)
          setState({
            ...form,
            errorMessage: { message: errorMessage, status: true }
          })
          scrollToTop()
        }
      })
      .catch(err => {
        console.log('error', pathName, 'with', err.message)
        let errorMessage = ''
        if (err.message.includes('status code 500')) {
          errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 40, 500)
          setState({
            ...form,
            errorMessage: { message: errorMessage, status: true }
          })
          scrollToTop()
        }else {
          errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 40, err.response?.status)
          setState({
            ...form,
            errorMessage: { message: errorMessage, status: true }
          })
          scrollToTop()
        }
      })
  }

  const generateOTP = () => {
    const pathName = 'generateOTP'
    const payload = {
      mobileNumber: form.mobileNumber,
      userId: userStore.userId
    }
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('response.requestId : ' + response.requestId)

        if (response.message === 'successfully') {
          const referenceCode: string = response.requestId || ''
          tokenStore.setReOtp(referenceCode)
          console.log('tokenStore.referenceCode : ' + tokenStore.referenceCode)
          otpStore.setOtp('')
        } else {
          console.log('generateOTP not success!!!', response)
          const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 50, response?.status)
          otpStore.setOtp('')
          setState({
            ...form,
            errorMessage: { message: errorMessage, status: true }
          })
          scrollToTop()
        }
      })
      .catch(err => {
        console.log(err)
        const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 50, err.response?.status)
        setState({
          ...form,
          errorMessage: { message: errorMessage, status: true }
        })
        scrollToTop()
      })
  }

  const openTicket = () => {
    console.log('go to flow open ticket')
    console.log('userId : ' + userStore.userId)

    const pathName = 'openTicket'
    const payload = {
      userId: userStore.userId
    }
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('openTicket response : ' + response.result)

        if (response.result) {
          liff.closeWindow()
        } else {
          console.log('openTicket not success!!!')
          const errorMessage = t('viriyah.validate-message.service-error') + ` (API: openTicket, ${response})`
          setState({
            ...form,
            errorMessage: { message: errorMessage, status: true }
          })
        }
      })
      .catch(err => {
        console.log(err)
        const errorMessage = t('viriyah.validate-message.service-error') + ` (API: openTicket, ${err.message})`
        setState({
          ...form,
          errorMessage: { message: errorMessage, status: true }
        })
      })
  }

  const toBEyear = (e: string) => {
    const BEyear = parseInt(e.substr(0, 4)) + 543
    const dayMonth = e.substr(4, 4)
    return String(BEyear) + dayMonth
  }

  const chkBirthday = (e: string) => {
    let errorMessage
    const today = dayjs().format('YYYY-MM-DD')
    if (e > today) {
      return (errorMessage = 'วัน/เดือน/ปีเกิด ไม่ถูกต้อง')
    } else {
      return (errorMessage = '')
    }
  }

  return (
    <>
      <section ref={formDiv} id="register-form-page" className="pt-16">
        <div className="container">
          <div
            dangerouslySetInnerHTML={{
              __html: form.errorMessage.status
                ? `${t('viriyah.validate-message.login-form.logo')} <div style='width: 90%; padding-left: 2%;'><p> ${t(
                    form.errorMessage.message
                  )} </p></div></div>`
                : ''
            }}
          />

          <div
            dangerouslySetInnerHTML={{
              __html: form.dopaErrorMessage.status
                ? `${t('viriyah.validate-message.login-form.logo')} <div style='width: 90%; padding-left: 2%;'><p> ${t(
                    form.dopaErrorMessage.message
                  )} </p></div></div>`
                : ''
            }}
          />

          <div
            dangerouslySetInnerHTML={{
              __html: form.memberUserErrorMessage.status
                ? `${t('viriyah.validate-message.login-form.logo')} <div style='width: 90%; padding-left: 2%;'><p> ${t(
                    form.memberUserErrorMessage.message
                  )} </p></div></div>`
                : ''
            }}
          />

          <div
            dangerouslySetInnerHTML={{
              __html: form.memberUserErrorMessage.status ? t('viriyah.validate-message.check-my-policy.link-text') : ''
            }}
            onClick={openTicket}
          />

          
          <h6 className="" id="register-title">
            {t('viriyah.register-form-page.title')}
          </h6>
          <Text fontSize="16px" color="#757575">
            {t('viriyah.make-claim-page.title-alert-off')}
          </Text>
          <br />
          <Text fontSize="16px" color="#f72c40">
            {t('viriyah.register-form-page.notice')}
          </Text>
          
          

          <div className="form-group">
            {/* ชื่อ */}
            <label className="label-text" htmlFor="firstName">
              {t('viriyah.register-form-page.label-firstName')}
            </label>
            <input
              className={form.firstNameStatus.message === '' ? 'form-input mt-custom-5' : 'wrong mt-custom-5'}
              type="text"
              id="firstName"
              name="firstName"
              value={form.firstName}
              placeholder={t('viriyah.register-form-page.input-placeholder-firstName')}
              style={{ fontSize: '18px', color: '#212121', padding: '.375rem .75rem' }}
              onChange={handleTextChange}
              onBlur={checkValidate}
              autoComplete="off"
            />
            <ValidateMessage
              message={form.firstNameStatus.message !== '' ? t(form.firstNameStatus.message) : '‏‏‎ ‎'}
            />

            {/* นามสกุล */}
            <label className="label-text" htmlFor="lastName">
              {t('viriyah.register-form-page.label-lastName')}
            </label>
            <input
              className={form.lastNameStatus.message === '' ? 'form-input normal mt-custom-5' : 'wrong mt-custom-5'}
              type="text"
              id="lastName"
              name="lastName"
              value={form.lastName}
              placeholder={t('viriyah.register-form-page.input-placeholder-lastName')}
              style={{ fontSize: '18px', color: '#212121', padding: '.375rem .75rem' }}
              onChange={handleTextChange}
              onBlur={checkValidate}
              autoComplete="off"
            />
            <ValidateMessage message={form.lastNameStatus.message !== '' ? t(form.lastNameStatus.message) : '‏‏‎ ‎'} />

            {/* วัน/เดือน/ปีเกิด */}
            <label className="label-text" htmlFor="birthday">
              {t('viriyah.register-form-page.label-birthday')}
            </label>
            <div className="cal-wrp">
              <div className="btnCal-wrp">
                <input
                  className={
                    form.birthdayStatus.message === ''
                      ? 'btnCal-click normal mt-custom-5'
                      : 'btnCal-click wrong mt-custom-5'
                  }
                  type="date"
                  id="birthday"
                  name="birthday"
                  value={form.birthday}
                  style={{ padding: '.375rem .75rem' }}
                  placeholder={t('viriyah.register-form-page.input-placeholder-birthday')}
                  onChange={handleTextChange}
                  onBlur={checkValidate}
                  autoComplete="off"
                />
              </div>
              <span className="open-button">
                <button type="button">
                  <img
                    src="https://upload.convolab.ai/viriyah-dev%2F439019bc-bc4f-479c-b059-57ba0225c93c.png"
                    alt="viriyah-dev%2F439019bc-bc4f-479c-b059-57ba0225c93c"
                  />
                </button>
              </span>
            </div>
            <ValidateMessage message={form.birthdayStatus.message !== '' ? t(form.birthdayStatus.message) : '‏‏‎ ‎'} />

            {/* เลขประจำตัวบัตรประชาชน */}
            <label className="label-text" htmlFor="idCardNumber">
              {t('viriyah.register-form-page.label-idCardNumber')}
            </label>
            <InputMask
              mask="9-9999-99999-99-9"
              maskChar=""
              value={form.idCardNumber}
              name="idCardNumber"
              onChange={handleTextChange}
              onBlur={checkValidate}
            >
              {(inputProps: any) => (
                <Input
                  {...inputProps}
                  className={form.idCardNumberStatus.message === '' ? 'normal mt-custom-5' : 'wrong mt-custom-5'}
                  id="idCardNumber"
                  type="tel"
                  pattern="\d*"
                  autoComplete="off"
                  placeholder={t('viriyah.register-form-page.input-placeholder-idCardNumber')}
                  style={{ fontSize: '18px', color: '#212121' }}
                />
              )}
            </InputMask>
            <ValidateMessage
              message={form.idCardNumberStatus.message !== '' ? t(form.idCardNumberStatus.message) : '‏‏‎ ‎'}
            />

            {/* เลขหลังบัตรประชาชน */}
            <label className="label-text" htmlFor="laser">
              {t('viriyah.register-form-page.label-laser')}
            </label>
            <InputMask
              mask="aa9-9999999-99"
              maskChar=""
              value={form.laser.toUpperCase()}
              name="laser"
              onChange={handleTextChange}
              onBlur={checkValidate}
            >
              {(inputProps: any) => (
                <Input
                  {...inputProps}
                  className={form.laserStatus.message === '' ? 'normal mt-custom-5' : 'wrong mt-custom-5'}
                  id="laser"
                  type="text"
                  autoComplete="off"
                  placeholder={t('viriyah.register-form-page.input-placeholder-laser')}
                  style={{ fontSize: '18px', color: '#212121' }}
                />
              )}
            </InputMask>
            <ValidateMessage message={form.laserStatus.message !== '' ? t(form.laserStatus.message) : '‏‏‎ ‎'} />

            {/* อีเมล */}
            <label className="label-text" htmlFor="email">
              {t('viriyah.register-form-page.label-email')}
            </label>
            <input
              className={form.emailStatus.message === '' ? 'form-input normal mt-custom-5' : 'wrong mt-custom-5'}
              type="text"
              id="email"
              name="email"
              value={form.email}
              placeholder={t('viriyah.register-form-page.input-placeholder-email')}
              style={{ fontSize: '18px', color: '#212121', backgroundColor: 'white', padding: '.375rem .75rem' }}
              onChange={handleTextChange}
              onBlur={checkValidate}
              autoComplete="off"
            />
            <ValidateMessage message={form.emailStatus.message !== '' ? t(form.emailStatus.message) : '‏‏‎ ‎'} />

            {/* เบอร์ติดต่อ */}
            <label className="label-text" htmlFor="mobileNumber">
              {t('viriyah.register-form-page.label-mobileNumber')}
            </label>
            <InputMask
              mask="9999999999"
              maskChar=""
              value={form.mobileNumber}
              name="mobileNumber"
              onChange={handleTextChange}
              onBlur={checkValidate}
            >
              {(inputProps: any) => (
                <Input
                  {...inputProps}
                  className={form.mobileNumberStatus.message === '' ? 'normal mt-custom-5' : 'wrong mt-custom-5'}
                  id="mobileNumber"
                  type="tel"
                  pattern="\d*"
                  autoComplete="off"
                  placeholder={t('viriyah.register-form-page.input-placeholder-mobileNumber')}
                  style={{ fontSize: '18px', color: '#212121' }}
                />
              )}
            </InputMask>
            <ValidateMessage
              message={form.mobileNumberStatus.message !== '' ? t(form.mobileNumberStatus.message) : '‏‏‎ ‎'}
            />
          </div>
        </div>

        <div className="bottom-section w-100">
          <Button
            id="button-style"
            isDisable={checkFormInput()}
            customBgColor="#0033A2"
            optionalClass="w-100 pt-3 pb-3"
            textColor="white"
            onClick={chkDOPA}
          >
            {t('viriyah.register-form-page.button-login')}
          </Button>
        </div>
      </section>
    </>
  )
})
